import { LookListing } from 'Client/redux/looksPage/types';
import { LookPromotion } from 'Client/redux/looksPromotionalElements/types';

export type LLPGridTile =
    | {
          type: 'look';
          data: LookListing;
      }
    | {
          type: 'promotion';
          data: LookPromotion;
      };

const getGridTiles = (looks: LookListing[], promotions: LookPromotion[]): LLPGridTile[] => {
    const availablePromotions = [...promotions].sort((a, b) => a.position - b.position);
    let displayedPromotions = 0;
    let nextPromotion: LookPromotion | undefined = availablePromotions.shift();

    return looks.reduce((result, look, index) => {
        // we should consider already added promotions in our calculation to show the look only betweem landscape tiles
        const position = index + (displayedPromotions % 2);

        if (nextPromotion && position === nextPromotion.position) {
            const res: LLPGridTile[] = [
                ...result,
                { type: 'promotion', data: nextPromotion },
                { type: 'look', data: look },
            ];
            nextPromotion = availablePromotions.shift();
            displayedPromotions += 1;
            return res;
        }
        return [...result, { type: 'look', data: look }];
    }, []);
};

export default getGridTiles;
